import type { FormEvent, HTMLProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { ButtonGroup } from './ButtonGroup'
import type { FormVariant } from './config'
import { defaultVariant } from './defaultVariant'
import { FormItem } from './FormItem'
import { FormProvider } from './FormProvider'

export const submitButtonTextDefiniton = ['save', 'send', 'add'] as const
export type SubmitButtonText = (typeof submitButtonTextDefiniton)[number]

type FormProps = {
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void
  children: ReactNode
  variant?: FormVariant
} & HTMLProps<HTMLFormElement>

export const Form = ({ children, onSubmit, variant = defaultVariant, ...props }: FormProps) => {
  return (
    <FormProvider variant={variant}>
      <form
        {...props}
        className={twMerge('w-full', props.className)}
        onSubmit={e => {
          e.preventDefault()
          onSubmit?.(e)
        }}
      >
        {variant.form({ children })}
      </form>
    </FormProvider>
  )
}

Form.Item = FormItem
Form.ButtonGroup = ButtonGroup
